<!--
  Container for survey components:
    QuestionnaireTabs

  To avoid the problem of a variable height question panel,
  we have put the survey questions into their own page, 
  with no neighbours below.
-->
<template>
  <v-container fluid class="pa-0 white-background">
    <QuestionnaireTabs></QuestionnaireTabs>
  </v-container>
</template>

<style>
@import "../assets/styles/styles.css";
</style>

<script>
import overrideQuestionModel from "../model/override-question-model.js";
import QuestionnaireTabs from "./QuestionnaireTabs.vue";
export default {
  name: "survey",
  components: { QuestionnaireTabs },

  data: () => ({}),
  computed: {
    questionModel() {
      return overrideQuestionModel.enrichModel();
    },
  },
};
</script>
